<script>
 import Dropdown from './Dropdown.svelte';
 import {onMount} from 'svelte';
 import { restapi } from './store.js';
 import { mockHttpRequest } from './localCalibre.js';
 import { motw_reverse_svg } from './svgs.js';

 export let mock;

 let librariansDroplist = [];
 let selectedLibrarian;
 export let t;

 async function fetchLibrarians() {
     var url = `${$restapi}librarians/on`;
     if (mock) {
         var data = mockHttpRequest(CALIBRE_BOOKS1.books, url, 48, "books")
     } else {
         const res = await fetch(url);
         var data = await res.json();
     }
     librariansDroplist = data._items.sort();
 };

 function toggleT() {
     t = !t;
 }
 $: {
     if (selectedLibrarian && selectedLibrarian !== 'LIBRARIANS') {
         location.hash = `#/search/librarian/${selectedLibrarian.toLowerCase()}`;
     }
 }

</script>

<style>
 .hamburger-icon {
     height: 0.7em;
     background: linear-gradient(to bottom, #fff 0%, #fff 20%, transparent 20%, transparent 40%, #fff 40%, #fff 60%, transparent 60%, transparent 80%, #fff 80%, #fff 100%);
 }

 .motw-bookmark {
     border: 1.2em solid red;
     border-right-color: white;
 }
 .motw-bookmark:active {
     color: #fed7d7;
 }
</style>
<div class="flex mb-1 mt-1 justify-between w-full">
    <div class="inline-flex bg-motw-red">
        <img on:click={()=> location.hash = ""} alt="let's share books" class="cursor-pointer pt-1 pl-1 pr-1 h-10 monocle:h-8 phone:h-8" src="{motw_reverse_svg}" />
        <div class="pt-4 pl-1 pr-1 monocle:hidden phone:hidden">
            <div class="hamburger-icon content-center">&nbsp;</div>
        </div>
        <Dropdown on:dropdownClick={fetchLibrarians} bind:selectedItem={selectedLibrarian} defaultItem={"LIBRARIANS"} droplist={librariansDroplist} />
    </div>
    <div on:click="{toggleT}" class="hover:underline cursor-pointer pt-2 text-motw-blue bg-white text-base font-bold text-center monocle:pr-1 phone:pr-1">show {#if t}covers{:else}list{/if}</div>
    <a class="motw-bookmark hover:underline monocle:hidden phone:hidden flex text-lg font-bold pr-5 h-0 text-white items-center bg-motw-red" href="https://www.memoryoftheworld.org">MEMORY OF THE WORLD</a>
</div>
